// extracted by mini-css-extract-plugin
module.exports = {"comp":"pc_comp__FzH16"};